export const EVENTS_COLORS: { [key: string]: string } = {
  Festival: "#D5F5D5",
  Sports: "#FFC0CB",
  "fashion week": "#FFDAB9",
  "international holiday": "#E3E392",
  "movie release": "#DBC0D5",
  "wedding dates": "#F5F5DC",
  "n/a": "#DBC0D5",
};

export const EVENT_PERIODS = [
  { label: "J-F-M", months: [1, 2, 3] },
  { label: "A-M-J", months: [4, 5, 6] },
  { label: "J-A-S", months: [7, 8, 9] },
  { label: "O-N-D", months: [10, 11, 12] },
];

export const defaultMaterials = ["Color", "Pattern", "Embroidery", "Fabric"];

export const sidebarOpenWidth = 265;
export const sidebarClosedWidth = 105;
export const preferencesOpenWidth = 200;
export const preferencesClosedWidth = 32;
export const trendsOpenWidth = 450;
export const trendsClosedWidth = 32;
export const minSpaceBetweenItemsInCarousel = 10;
export const instaPostWidthWhenTrendsOpen = 158;
export const instaPostWidthWhenTrendsClosed = 240;
export const instaPostHeightWhenTrendsOpen = 260;
export const instaPostHeightWhenTrendsClosed = 390;

export const materialsForBackend = {
  colorAnalysis: { value: false, label: "Color" },
  pattern: { value: false, label: "Pattern" },
  embroidery: { value: false, label: "Embroidery" },
  fabric: { value: false, label: "Fabric" },
};

export const stylingDetailsForBackend = {
  shapes: { value: false, label: "Fit" },
  apparel_name: { value: false, label: "Styles" },
  sleeves: { value: false, label: "Sleeve Details" },
  necklines_and_collars: { value: false, label: "Necklines & Collars" },
  hem_types: { value: false, label: "Hem Types" },
  length: { value: false, label: "Lengths" },
  pockets: { value: false, label: "Pockets" },
  cuffs: { value: false, label: "Cuffs" },
  details: { value: false, label: "Details" },
  placket: { value: false, label: "Placket Types" },
  waistband: { value: false, label: "Waistband" },
};

export const barGraphConfig = [
  {
    minContribution: 0,
    maxContribution: 33,
    color: "#ecd9df",
    impact: "Moderate",
    bet: "Risky",
  },
  {
    minContribution: 34,
    maxContribution: 66,
    color: "#107da4",
    impact: "Significant",
    bet: "Neutral",
  },
  {
    minContribution: 67,
    maxContribution: 100,
    color: "#3c3c3c",
    impact: "Strong",
    bet: "Safe",
  },
];

export const TrendsPerPage = 10;
export const postsPerTrend = 50;

export const keysToRemoveForGraphAnalysis = [
  "page",
  "pageSize",
  "posts_per_trend",
  // "req_id",
  "colorAnalysis",
  "selected_color",
  "color_analysis_level",
  "level2Color",
  "curve_window",
  "curve_filter_type",
  "curve_query_type",
];
export const keysToRemoveForSnapshot = keysToRemoveForGraphAnalysis.filter(
  key => !["color_analysis_level"].includes(key)
);

//Trend Filters
export const trendFilters = ["Most Popular", "New and Emerging"];
export const filterBy = ["Trend Score", "Impact Score"];
export type TrendsFilterType = (typeof trendFilters)[number];
export const mappedTrendFilterType: Record<TrendsFilterType, string> = {
  "Most Popular": "most_popular",
  "New and Emerging": "new_and_emerging",
};

export const trendCurvesFilters = ["Most Popular", "New and Emerging"];
export type TrendCurvesFilterType = (typeof trendCurvesFilters)[number];

export const mappedFilterTypeTrendCurves: Record<
  TrendCurvesFilterType,
  string
> = {
  "Most Popular": "most_popular",
  "New and Emerging": "new_and_emerging",
};

export const trendCurveWindows = [
  "Month",
  "6 Months",
  "Quarter",
  "Year",
] as const;

export type TrendCurveWindowType = (typeof trendCurveWindows)[number];

export const mappedTrendCurveWindow: Record<TrendCurveWindowType, string> = {
  Month: "month",
  "6 Months": "6_months",
  Quarter: "quarter",
  Year: "year",
};

export const getTrendCurveWindowLabel = (curveWindow?: string): string => {
  if (curveWindow === "3_months") {
    return "Quarter";
  }
  const entry = Object.entries(mappedTrendCurveWindow).find(
    ([, value]) => value === curveWindow
  );
  return entry?.[0] || "Month";
};

export const normalizeTrendCurveWindowLabel = (
  label?: string
): TrendCurveWindowType => {
  if (label === "3 Months") {
    return "Quarter";
  }
  if (label && label in mappedTrendCurveWindow) {
    return label as TrendCurveWindowType;
  }
  return "Month";
};
// const dummyFilterType = ["Month on Month", "Week on Week"];
// type FilterType = (typeof dummyFilterType)[number];
// const mappedFilterType: Record<FilterType, string> = {
//   "Month on Month": "month_on_month",
//   "Week on Week": "week_on_week",
// };
export const SIDEBAR_GRAPH_WIDTH = 430;

export type COLOR_ANALYSIS_LEVELS = "LEVEL1" | "LEVEL2" | "LEVEL3";
export const MIN_VALUE_FOR_COLOR_ANALYSIS_LEVEL1 = 3;
export const BASE_VALUE_FOR_COLOR_ANALYSIS_LEVEL1 = 300;

export const INVERT_COLOR_THRESHOLD = 170;
export const LEVEL1_BACKGROUND_COLOR = "#f6f6f6";

export const KEYS_TO_REMOVE_FOR_OVERALL_ANALYSIS_TABLE = [
  "tNo",
  "contribution",
  "impact",
  "bet",
  "graphColour",
  "raw_contribution",
  "total_trend_score",
  "avg_trend_score",
  "max_trend_score",
  "count",
  "Past Volume",
  "Recent Volume",
  "Raw Trend Score",
  "total_weightage",
  "contribution_percentile",
  "impact_score",
  "impact_value",
  "Impact Value",
  "Impact Score",
  "Trend Score",
  "undefined",
  "Product Type",
];

export const MAX_POSTS_PER_TREND_FOR_SNAPSHOT_IMAGE = 7;
export const MAX_TRENDS_FOR_SNAPSHOT_IMAGE = 3;

export const MAX_TRENDS_SIZE = 140;
export const POSTS_PER_TREND = 50;
/** Max bars shown on Overall Analysis chart (sidebar, expanded, snapshot). */
export const OVERALL_ANALYSIS_GRAPH_MAX_BARS = 20;
export const DESIGNER_PAGE_SIZE = 50;

/** When true, trend analysis requires at least a start date or end date. */
export const TREND_DATE_REQUIRED = true;

export type SearchType = "Internet" | "ICH data";
